import { render, staticRenderFns } from "./sim-management.vue?vue&type=template&id=30c4626a&scoped=true"
import script from "./sim-management.vue?vue&type=script&lang=js"
export * from "./sim-management.vue?vue&type=script&lang=js"
import style0 from "./sim-management.vue?vue&type=style&index=0&id=30c4626a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4626a",
  null
  
)

export default component.exports